import { Eye, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function ImpersonationBanner() {
  const { isImpersonating, user, stopImpersonating } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const onReturn = async () => {
    await stopImpersonating();
    navigate("/users");
  };

  return (
    <div className="flex h-10 items-center justify-between gap-3 bg-amber-500 px-6 text-sm text-white">
      <div className="flex items-center gap-2 font-medium">
        <Eye className="h-4 w-4" />
        <span>
          Viewing as <span className="font-semibold">{user?.full_name}</span>{" "}
          <span className="capitalize text-amber-50/90">({user?.role})</span> — testing mode
        </span>
      </div>
      <button
        onClick={onReturn}
        className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-white/15 px-2.5 py-1 font-medium transition-colors hover:bg-white/25"
      >
        <LogOut className="h-3.5 w-3.5" />
        Return to admin
      </button>
    </div>
  );
}
